export function initScrollHandlers($) {
  checkIfMenuOverlapsContentGrid();
  // Checks and adds classes to invert menu-bruger and hide logo
  var offsetCheck = function() {
    // Current Scroll position
    var value = $(document).scrollTop();

    var isInHeader = false;
    // if ($(".background:not(.background-white)").length > 0) {

    // }

    var shouldInvert = false;
    if (reverseArray.length) {
      for (var i = 0, il = reverseArray.length; i < il; i++) {
        let arr = reverseArray[i];

        // Check for arr.mobileOnly
        if (value >= arr.top - 50 && value + 45 <= arr.top + arr.height) {
          if (arr.mobileOnly) {
            if (window.innerWidth < 1024) {
              shouldInvert = true;
            }
          } else {
            shouldInvert = true;
          }
        }
      }
    }

    checkIfMenuOverlapsContentGrid();

    if (shouldInvert && !isInHeader) {
      $(".menu-burger").removeClass("reverse");
    }
  };

  $(document).on(
    "scroll touchmove touchstart resize ready pageshow",
    offsetCheck
  );

  var prevScrollpos = window.pageYOffset;
  window.onscroll = function() {
    var currentScrollPos = window.pageYOffset;
    if (currentScrollPos - prevScrollpos > 5) {
      $(".main-menu__container").removeClass("active");
      $(".menu-burger").removeClass("active");
      $(".main-logo").removeClass("on-menu");
      $(".wrapper").removeClass("blur");
    }

    if (typeof flickityPlayers !== "undefined" && flickityPlayers.length) {
      for (var i = 0, il = flickityPlayers.length; i < il; i++) {
        if (!flickityPlayers[i].isPlaying) {
          let obj = flickityPlayers[i];
          if (
            currentScrollPos + window.innerHeight > $(obj.elem).offset().top &&
            currentScrollPos <
              $(obj.elem).offset().top + $(obj.elem).outerHeight()
          ) {
            obj.isPlaying = true;
            obj.player.unpausePlayer();
          }
        }
      }
    }
    prevScrollpos = currentScrollPos;
  };

  // Initial trigger
  window.requestAnimationFrame(offsetCheck);
}

export function checkIfMenuOverlapsContentGrid() {
  // Don't runt unless we have a content-grid
  if (!jQuery(".wrapper-grid-filter").length) {
    return;
  }

  // When overlapping the content-grid, invert menu
  if (hasOverlap(".wrapper-grid-filter", ".menu-burger")) {
    jQuery(".menu-burger").addClass("reverse");
  } else if ($(".menu-burger.reverse").length) {
    jQuery(".menu-burger").removeClass("reverse");
  }
}

function hasOverlap(elem1, elem2) {
  var objOne = $(elem1);
  var objTwo = $(elem2);
  var offsetTwo = objTwo.offset();
  var offsetOne = objOne.offset();
  var topOne = offsetOne.top;
  var topTwo = offsetTwo.top;
  var leftOne = offsetOne.left;
  var leftTwo = offsetTwo.left;
  var widthOne = objOne.width();
  var widthTwo = objTwo.width();
  var heightOne = objOne.height();
  var heightTwo = objTwo.height();
  var leftTop =
    leftTwo > leftOne &&
    leftTwo < leftOne + widthOne &&
    topTwo > topOne &&
    topTwo < topOne + heightOne
  var rightTop =
    leftTwo + widthTwo > leftOne &&
    leftTwo + widthTwo < leftOne + widthOne &&
    topTwo > topOne &&
    topTwo < topOne + heightOne
  var leftBottom =
    leftTwo > leftOne &&
    leftTwo < leftOne + widthOne &&
    topTwo + heightTwo > topOne &&
    topTwo + heightTwo < topOne + heightOne
  var rightBottom =
    leftTwo + widthTwo > leftOne &&
    leftTwo + widthTwo < leftOne + widthOne &&
    topTwo + heightTwo > topOne &&
    topTwo + heightTwo < topOne + heightOne;
  return leftTop || rightTop || leftBottom || rightBottom;
}



// WEBPACK FOOTER //
// ./assets/js/modules/scroll-handlers.js